import 'core-js/stable';
import 'regenerator-runtime/runtime';
import "friendly-challenge/widget";

// The following have been added for removing webpack-jquery-ui from dependencies
import './apocore/js/wpReplace/selectmenu'
import './apocore/js/wpReplace/accordion'
import './apocore/js/wpReplace/button'

import Swiper from 'swiper/bundle';

import './apocore/js/main.js';

import './apocore/js/buttons.js';
import './apocore/js/browser-detection';

import './apocore/js/custom/advisor';
import './apocore/js/custom/anchorNav';
import './apocore/js/custom/backgroundImage';
import './apocore/js/custom/btn-search';
import './apocore/js/custom/checkboxDownload';
import './apocore/js/custom/checkedServiceOffering';
import './apocore/js/custom/cioPage';
import './apocore/js/custom/contact';
import './apocore/js/custom/contactComponent';
import './apocore/js/custom/contactModal';
import './apocore/js/custom/csvToArrayv21';
import './apocore/js/custom/dropdown';
import './apocore/js/custom/formCsrf';
import './apocore/js/custom/formSummary';
import './apocore/js/custom/hideUrlParameters';
import './apocore/js/custom/jquery.L04ElasticSearch';
import './apocore/js/custom/jquery.searchsuggester';
import './apocore/js/custom/mapOverlay';
import './apocore/js/custom/navigation';
import './apocore/js/custom/openAccount';
import './apocore/js/custom/overviewAccount';
import './apocore/js/custom/pictureWithZoom';
import './apocore/js/custom/product';
import './apocore/js/custom/removeInlineStyle-table';
import './apocore/js/custom/replaceVariables';
import './apocore/js/custom/salesForceApiForm';
import './apocore/js/custom/scrollable-table';
import './apocore/js/custom/subsidiaryOverview';
import './apocore/js/custom/video';
import './apocore/js/components/apo-contact-modal/apo-contact-modal';
import './apocore/js/components/form/fieldvalidation';
import './apocore/js/components/form/form';
import './apocore/js/components/accordion/accordion';
import './apocore/js/contentHub/loadMore';
import './apocore/js/custom/accordion';
import './apocore/js/custom/bypassBlocksButton';

export const ApoSwiper = Swiper;
